module.exports = __webpack_public_path__ + "img/home@1x.817dd650.png";